import { Card } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./ChartCard.style.less";

const ChartCard = ({ children, ...cardProps }) => (
  <Card
    size="small"
    {...cardProps}
    className={classNames("chart-card", cardProps?.className)}
  >
    {children}
  </Card>
);

ChartCard.propTypes = {
  children: PropTypes.node,
};

export default ChartCard;
